import * as React from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { Widget } from "../widget-types/Widget";
import { SearchInput } from "@similarweb/ui-components";
import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";

export class LeadingFoldersDashboardTableWidgetFilters extends React.PureComponent<any, any> {
    protected selectedFilters: any = {};

    constructor(props) {
        super(props);
        this.selectedFilters = {
            filter: this.props.widgetFilters.filter,
            includeSubDomains: false,
        };
        this.props.changeFilter(this.getSelectedFilters());
    }

    private getSearchValue() {
        const filterObject: any = Widget.filterParse(this.props.widgetFilters.filter);
        const filterObjectItem = filterObject[Object.keys(filterObject)[0]];
        return filterObjectItem && filterObjectItem.hasOwnProperty("value")
            ? filterObjectItem.value.replace(/"/g, "")
            : "";
    }

    private getSelectedFilters() {
        const filters = [];
        for (const filter in this.selectedFilters) {
            filters.push({ name: filter, value: this.selectedFilters[filter] });
        }
        return filters;
    }

    private onSearch = (value: string) => {
        const filterValue = Widget.filterStringify({
            Folder: { operator: "contains", value: `"${value}"` },
        });
        this.selectedFilters.filter = filterValue;
        this.props.changeFilter(this.getSelectedFilters());
    };

    private onSelectincludeSubDomains = (item) => {
        this.selectedFilters.includeSubDomains = item.id;
        this.props.changeFilter(this.getSelectedFilters());
    };

    render() {
        return (
            <div
                key="dynamicFiltersContainer"
                className="filters"
            >
                <div
                    key="searchterm"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.searchterm`}</I18n>
                    </h5>
                    <SearchInput
                        defaultValue={this.getSearchValue()}
                        onChange={this.onSearch}
                        debounce={400}
                    />
                </div>
                <div
                    key="includeSubDomains"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.includeSubDomains`}</I18n>
                    </h5>
                    <StatefulDropdown
                        // this filter was not remove in past by mistake, as part of PII effort(Jira sim-26282) we blocked the option to requests includeSubDomains
                        // in popularPages and Folders (all requests should have includeSubDomains set to false).
                        // It has been disabled but not removed in order not to confuse users who are used to seeing the filter.
                        disabled={true}
                        key="includeSubDomainsFilter"
                        items={[{ id: "false", text: "No" }]}
                        selectedId={"false"}
                    />
                </div>
            </div>
        );
    }
}
